import { motion } from "framer-motion"
import { useInView } from "react-intersection-observer"

const WebEngineering = () => {
    const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 })

    return (
        <div className="w-full mx-auto p-6 lg:px-12 lg:py-16 text-zinc-800 dark:text-zinc-200 text-sm" ref={ref}>
            <div className="grid lg:grid-cols-2 gap-12 items-center justify-between">

                <motion.div 
                    className="lg:w-10/12 space-y-6 lg:order-1"
                    initial={{ opacity: 0, x: -50 }}
                    animate={inView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.6 }}
                >
                    <div className="flex flex-row text-zinc-800 dark:text-zinc-200 font-light items-center justify-between">
                        <div className="flex justify-start space-x-3 items-center">
                            <span className="text-purple-600 dark:text-purple-400 font-mono text-xl font-bold">02</span>
                            <span className="text-3xl lg:text-4xl font-bold text-zinc-900 dark:text-white">Prompt Engineering Workshops</span>
                        </div>
                    </div>
                    <p className="text-zinc-600 dark:text-zinc-400 font-roboto font-light leading-relaxed">
                        Refine the instructions your teams pass to language models. We run structured prompt engineering workshops that walk marketing, sales, product, and developer teams through prompt structures, dynamic templates, system prompts, and test validation routines.
                    </p>
                    <p className="text-zinc-600 dark:text-zinc-400 font-roboto font-light leading-relaxed">
                        By training your team in advanced prompting strategies, we make AI outputs highly accurate, structured, and compliant with your data formats.
                    </p>
                </motion.div>

                <motion.div 
                    className="mx-auto lg:w-9/12 w-full lg:order-2"
                    initial={{ opacity: 0, x: 50 }}
                    animate={inView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.6 }}
                >
                    <div className="p-6 rounded-2xl border border-slate-200 dark:border-purple-500/20 bg-white dark:bg-[#202222] shadow-[0_4px_20px_rgba(0,0,0,0.03)] dark:shadow-[0_0_35px_rgba(168,85,247,0.08)] hover-glow transition-all duration-300 font-mono text-[10px]">
                        <div className="text-zinc-500 dark:text-slate-500 mb-3"># PROMPT REFINEMENT ENGINE</div>
                        <div className="space-y-4">
                            <div className="p-3 bg-red-50 dark:bg-red-950/10 rounded-lg border border-red-200 dark:border-red-500/10">
                                <span className="text-red-600 dark:text-red-400 font-bold">VAGUE:</span>
                                <p className="text-zinc-600 dark:text-slate-400 mt-1">"Write an email template to check in on a customer."</p>
                            </div>
                            <div className="text-center text-purple-600 dark:text-purple-500 font-medium">↓ (Refined via Chain-of-Thought)</div>
                            <div className="p-3 bg-green-50 dark:bg-green-950/10 rounded-lg border border-green-200 dark:border-green-500/10">
                                <span className="text-green-600 dark:text-green-400 font-bold">OPTIMIZED SYSTEM PROMPT:</span>
                                <p className="text-zinc-800 dark:text-slate-300 mt-1">
                                    "You are an expert customer success manager. Follow these rules:<br/>
                                    1. Tone: Friendly, concise, professional.<br/>
                                    2. Structure: Hook, value statement, call to action.<br/>
                                    3. Format response in JSON."
                                </p>
                            </div>
                        </div>
                    </div>
                </motion.div>

            </div>
        </div>
    )
}

export default WebEngineering